module.exports = __webpack_public_path__ + "static/img/live-bg-1.604b023a.jpg";